import { theme } from 'antd'

export const { useToken } = theme
